<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <Header></Header>
		<div class="login login-send">
		    <div class="home-prize ac">
          <img style="width: 70%" src="../../static/images/login_tip.png" />
		    </div>
		  <div class="landing-page">
		    <div class="input-div">
		      <div  class="span mt20 fs33 fw7" style="font-weight: 800;margin-bottom: 15px;color: #f0831d">{{$t('loginTips')}}</div>
		      <div class="input-item mt20">
		        <div class="input-item2">
		          <span class="app-en">09</span>
		          <input class="input" v-model="mobile" type="number" placeholder="">
		        </div>
		      </div>
		    </div>

		    <div class="ac " style="margin-top: 40px">
		      <div class="drown-list login-list" style="width: 100%">
		        <div class="disflex" style="background:none;box-shadow: none;">
		          <div style="width: 50%" class="land-btn day_week" @click="goLogin()">
		            <span class="day">{{$t('subscribe')}}</span>
		          </div>
		        </div>
		      </div>
		    </div>
		    <div class="ac otp-b disflex mt100">
		      <div style="color: white" class="icon icon2 fw7" @click="getToNav('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
		      <div style="color: white" class="icon icon2 fw7" @click="getToNav('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
		    </div>
		  </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        type:'',
        code:''
      }
    },
	created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    let that = this
    if (this.$route.query.mobile){
      that.mobile = this.$route.query.mobile;
    }
    if (this.$route.query.type){
      that.type = this.$route.query.type;
    }
	},
  methods: {
      getToNav(url){
        this.$router.push({path:'/'+url});
      },
      back(){
        this.$router.go(-1);
      },
		  goLogin(){
        let that = this
        if(!this.mobile){
          that.$utils.alertText(that.$t('loginTips'),80)
        }else{
          this.checkMobile();
          // this.testLogin()
        }
		},
    checkMobile(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let data = {
        "mobile":mobile
      }
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          const leare_language = r.data.userinfo.leare_language
          if (leare_language == "chinese") {
            that.$router.push({path:'/'})
          }else if (leare_language == "japanese"){
            window.location.href =  that.$japUrl+'?mobile=' + mobile;
          }else{
            that.$router.push({path:'/select'})
          }
        }else if(r.code==-1){
          if (that.type){
            this.startSub()
          }else{
            this.goLandPage();
          }
        } else{
          that.$utils.alertText(r.msg,100,2000);
        }
      })
    },
    //到land页
    goLandPage(){
      this.$router.push({path:'/land',query:{mobile:'09'+this.mobile,code:this.code,type:this.type}});
    },
    //直接订阅登录
    startSub(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let type  = this.type
      let queryParams = this.$route.query;
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            localStorage.setItem('avatar',r.data.userinfo.avatar)

            const leare_language = r.data.userinfo.leare_language
            if (leare_language == "chinese") {
              that.$router.push({path:'/'})
            }else if (leare_language == "japanese"){
              window.location.href =  that.$japUrl+'?mobile=' + mobile;
            }else{
              that.$router.push({path:'/select'})
            }
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    //测试阶段任意号码直接登录
    testLogin(){
      let that = this
      let mobile = '09'+this.mobile
      that.$parent.loadModal(true);
      let url = '/api/user/test_login'
      let data = {
        mobile:mobile
      }
      that.$api.post(url,data,r =>{
        that.$parent.loadModal(false);
        if(r.code === 1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          localStorage.setItem('avatar',r.data.userinfo.avatar)
          this.$router.push({path:'/'})
        }else{
          that.$utils.alertText(r.msg,80);
        }
      })
    }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
  .login-list .drown-li{min-width:320px;}
  .login-list .drown-li + .drown-li{margin-left: 30px;}
  .login-list .drown-li + .drown-li .disflex{background: #0065f3;}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue